import {Table} from "antd";

export const TableMetadata = ({metadata}) => {

    const columns = [
        {
            title: 'Name', dataIndex: 'name', key: 'name', onCell: (record) => ({
                style: {
                    fontSize: '12px',
                    fontWeight: '300',
                    padding: 5,
                    border: "none",
                }
            })
        },
        {title: 'Type',
            dataIndex: 'type',
            key: 'type',
            onCell: (record) => ({
                style: {
                    fontSize: '12px',
                    textAlign: 'right',
                    padding: 0,
                    border: "none",

                }
            })

        }]

    if (!metadata || metadata.length === 0) {
        return <div style={{textAlign: 'center', padding: '20px'}}>No metadata available</div>;
    }

    return <Table dataSource={metadata} columns={columns} size={"small"}
                  showHeader={false}
                  bordered={false}
                  pagination={false}></Table>

}